/**
 * Direct checkout: empty cart, add single line (qty 1), redirect to /checkout.
 * Triggered when product-info, sticky-atc, or form has data-direct-checkout="true".
 * Media gallery click: navigates to Shopify cart permalink /cart/{variantId}:1 (same as home abonos links), no product form required.
 */
(function () {
  function wantsDirectCheckout(form) {
    if (!form || form.tagName !== "FORM") return false;
    if (form.getAttribute("data-direct-checkout") === "true") return true;
    const pi = form.closest("product-info");
    if (pi && pi.getAttribute("data-direct-checkout") === "true") return true;
    const st = form.closest("sticky-atc");
    if (st && st.getAttribute("data-direct-checkout") === "true") return true;
    return false;
  }

  function getVariantId(form) {
    const idInput = form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]');
    if (!idInput) return null;
    const v = idInput.value;
    if (!v) return null;
    return String(v).trim();
  }

  function variantIdFromCartPermalink(url) {
    const m = String(url).match(/(\d+):\d+$/);
    return m ? m[1] : null;
  }

  /** Prefer live picker JSON, then any product form id input, then static theme product data. */
  function getCurrentVariantIdForGallery(productInfo, productId) {
    const raw = productInfo.querySelector("variant-picker [data-selected-variant]")?.innerHTML;
    if (raw) {
      try {
        const v = JSON.parse(raw);
        if (v && v.id != null) return String(v.id).trim();
      } catch (err) {
        /* ignore */
      }
    }
    const idInput =
      productInfo.querySelector('#product-form-' + productInfo.dataset.sectionId + ' input[name="id"]') ||
      productInfo.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      productInfo.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value).trim();
    const p = window._themeProducts && window._themeProducts[Number(productId)];
    if (!p) return null;
    if (p.selected_variant && p.selected_variant.id != null) return String(p.selected_variant.id).trim();
    if (p.selected_or_first_available_variant && p.selected_or_first_available_variant.id != null) {
      return String(p.selected_or_first_available_variant.id).trim();
    }
    return null;
  }

  function buildGalleryCartUrl(gallery, productInfo) {
    let url = (gallery.dataset.cartCheckoutUrl || "").trim();
    if (url) return url;
    const prefix = ((gallery.dataset.cartPermalinkPrefix || "").trim() || "/cart").replace(/\/$/, "");
    const productId = gallery.dataset.productId;
    const variantId = getCurrentVariantIdForGallery(productInfo, productId);
    if (!variantId) return "";
    return prefix + "/" + variantId + ":1";
  }

  /** Stock check: theme JSON first; if stale, trust variant-picker object for same id. */
  function canNavigateGalleryToVariant(productInfo, productId, variantId) {
    if (variantIsPurchasable(productId, variantId)) return true;
    const raw = productInfo.querySelector("variant-picker [data-selected-variant]")?.innerHTML;
    if (!raw) return false;
    try {
      const v = JSON.parse(raw);
      return !!(v && String(v.id) === String(variantId) && v.available);
    } catch (e) {
      return false;
    }
  }

  async function clearCart() {
    const cartRes = await fetch("/cart.js", { credentials: "same-origin" });
    if (!cartRes.ok) return;
    const cart = await cartRes.json();
    if (!cart.items || !cart.items.length) return;
    const updates = {};
    cart.items.forEach(function (item) {
      updates[item.key] = 0;
    });
    await fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
  }

  async function addOneAndCheckout(variantId) {
    const addRes = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    const data = await addRes.json().catch(function () {
      return {};
    });
    if (!addRes.ok || data.status) {
      const msg = (data && (data.description || data.message)) || "No se pudo añadir al carrito";
      throw new Error(msg);
    }
    window.location.href = "/checkout";
  }

  function setSpinner(form, on) {
    const pf = form && form.closest && form.closest("product-form");
    if (pf) {
      pf.classList.toggle("m-spinner-loading", !!on);
    }
  }

  function showCheckoutError(err) {
    console.error(err);
    if (window.MinimogTheme && window.MinimogTheme.Notification) {
      window.MinimogTheme.Notification.show({
        target: document.body,
        method: "appendChild",
        type: "error",
        message: (err && err.message) || "Error",
        last: 4000,
        sticky: true,
      });
    }
  }

  function variantIsPurchasable(productId, variantId) {
    const p = window._themeProducts && window._themeProducts[Number(productId)];
    if (!p || !p.variants || !variantId) return false;
    const id = String(variantId);
    const v = p.variants.find(function (x) {
      return String(x.id) === id;
    });
    return !!(v && v.available);
  }

  function runDirectCheckout(variantId, form) {
    if (!variantId) {
      console.warn("direct-checkout: missing variant id");
      return Promise.resolve();
    }
    setSpinner(form, true);
    return clearCart()
      .then(function () {
        return addOneAndCheckout(variantId);
      })
      .catch(showCheckoutError)
      .finally(function () {
        setSpinner(form, false);
      });
  }

  window.__RB_DIRECT_CHECKOUT__ = {
    run: runDirectCheckout,
    variantIsPurchasable: variantIsPurchasable,
  };

  document.addEventListener(
    "submit",
    function (e) {
      const form = e.target;
      if (!wantsDirectCheckout(form)) return;
      e.preventDefault();
      e.stopPropagation();

      const variantId = getVariantId(form);
      if (!variantId) {
        console.warn("direct-checkout: missing variant id");
        return;
      }

      runDirectCheckout(variantId, form);
    },
    true
  );

  /** Clic en la galería → enlace permanente al carrito /cart/{variantId}:1 (no requiere formulario en la página). */
  document.addEventListener(
    "click",
    function (e) {
      const gallery = e.target.closest("media-gallery[data-gallery-direct-checkout='true']");
      if (!gallery) return;

      const productInfo = gallery.closest("product-info");
      if (!productInfo || productInfo.getAttribute("data-direct-checkout") !== "true") return;
      if (gallery.classList.contains("m-media-gallery--checkout-disabled")) return;

      if (e.target.closest(".m-product-media--slider__thumbnails")) return;
      if (e.target.closest(".swiper-button-prev, .swiper-button-next, .swiper-pagination")) return;
      if (e.target.closest("model-viewer, video, iframe, .m-product-media__zoom-in")) return;
      if (e.target.closest("button")) return;

      const slide = e.target.closest(".m-product-media--item");
      if (!slide) return;
      /* Swiper loop duplicates slides (common with a single image); those clicks must still open cart. */

      const productId = gallery.dataset.productId;
      const url = buildGalleryCartUrl(gallery, productInfo).trim();
      if (!url) return;
      const variantId = variantIdFromCartPermalink(url);
      if (!variantId || !canNavigateGalleryToVariant(productInfo, productId, variantId)) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.assign(url);
    },
    true
  );

  function syncGalleryCartPermalink(sectionId, variant) {
    const pi = document.querySelector('product-info[data-section-id="' + sectionId + '"]');
    if (!pi) return;
    const gallery = pi.querySelector("media-gallery[data-gallery-direct-checkout='true']");
    if (!gallery) return;
    const prefix = (gallery.dataset.cartPermalinkPrefix || "/cart").replace(/\/$/, "");
    const ok = !!(variant && variant.available);
    gallery.classList.toggle("m-media-gallery--checkout-disabled", !ok);
    if (!ok || !variant || variant.id == null) {
      gallery.dataset.cartCheckoutUrl = "";
      return;
    }
    gallery.dataset.cartCheckoutUrl = prefix + "/" + variant.id + ":1";
  }

  if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, function (e) {
      const d = e && e.data;
      if (!d || d.sectionId == null) return;
      syncGalleryCartPermalink(d.sectionId, d.variant);
    });
  }
})();
